module.exports = __webpack_public_path__ + "static/media/ev-2.670ac937.jpg";